import Form from '@appComponents/ReduxFormControls';
import {BOOKING} from '@constants/resources';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import {CreateEventBooking} from '@graphql/eventBooking/mutation';
import validate from '@modules/events/forms/validatorEventBookings';
import {GetBlackoutZonesForDropdown} from '@graphql/blackoutZone/query';

export default function EventBookingGeoRestrictionsBlackoutZonesModel() {
    const DATA_MAP_KEY = 'eventGeoRestriction.blackout_zones';

    return {
        entityDataMapKey: 'booking',
        entityLabel: 'booking',
        formName: 'BookingGeoRestrictionsBlackoutZones',
        label: 'booking',
        editForm: false,
        resources: BOOKING,
        showChangeLog: false,
        title: null,
        usePopupMessages: true,
        validate: validate,
        messages: {
            boxName: {
                delete: 'event',
                error: 'formInnerErrorMessage',
                success: 'event',
            },
            text: { ...BASE_FORM_MESSAGES },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'booking.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            desktop_blackoutZones: {
                dataMapKey: DATA_MAP_KEY,
                optionsKey: 'blackoutZones',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Desktop',
                    name: 'desktop_blackoutZones',
                    allowClear: true,
                    multiple: true,
                    hidden: true,
                },
            },
            mobile_blackoutZones: {
                dataMapKey: DATA_MAP_KEY,
                optionsKey: 'blackoutZones',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Mobile',
                    name: 'mobile_blackoutZones',
                    allowClear: true,
                    multiple: true,
                    hidden: true,
                },
            },
            smart_tv_blackoutZones: {
                dataMapKey: DATA_MAP_KEY,
                optionsKey: 'blackoutZones',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Smart TV',
                    name: 'smart_tv_blackoutZones',
                    allowClear: true,
                    multiple: true,
                    hidden: true,
                },
            },
        },
        mutation: {
            createEntity: CreateEventBooking,
        },
        mutationOptions: {
            create: {
                refetchQueries: ['GetEventBookingsForTable'],
            },
            update: {
                refetchQueries: ['GetEventBookingsForTable'],
            },
            delete: {
                refetchQueries: ['GetEventBookingsForTable'],
            },
        },
        query: {
            getOptions: GetBlackoutZonesForDropdown,
        },
    };
}
